import React from 'react'
import { INITIAL_VALUES_ADD_LIMIT, VALIDATION_SCHEMA_ADD_LIMIT } from './utils';
import HOCButton from 'web/components/Button';
import NumberInput from 'web/components/form-elements/NumberInput';
import { Form, Formik, Field, ErrorMessage } from 'formik';

export default function AddAdminModal(props) {

    const submitLimit = data => {
        props.onEnter(data.values)
    }
    return (
        <div>
            <Formik
                initialValues={INITIAL_VALUES_ADD_LIMIT}
                validationSchema={VALIDATION_SCHEMA_ADD_LIMIT}
                onSubmit={(values) => {
                }}>
                {(props) => {
                    const { isValid, dirty, values, errors, touched, handleChange, setFieldValue } = props;
                    return (
                        <>
                            <Form>
                                <p className="mt-0">Threshold Limit</p>
                                <div style={{ display: 'flex' }}>
                                    <p style={{ height: '37px', borderRadius: '4px', border: 'solid 1px #87cdf1', background: '#ffffff', padding: '6px 12px', margin: '0px' }}>$</p>
                                    <div style={{ width: '100%' }}>
                                        <NumberInput
                                            name='amount'
                                            showErrorMessages={true}
                                        />
                                    </div>
                                </div>

                                <div style={{ marginTop: '15px', textAlign: '-webkit-center' }}>
                                    <HOCButton
                                        type='app-green-button submitBtn'
                                        handleClick={() => {
                                            submitLimit(props)
                                        }}
                                        disabled={!(isValid && dirty)}>
                                        Submit
                                    </HOCButton>
                                </div>
                            </Form>
                        </>
                    );
                }}
            </Formik>
        </div>
    )
}